import { render, staticRenderFns } from "./CustomerGenderEdit.vue?vue&type=template&id=8008a19c"
import script from "./CustomerGenderEdit.vue?vue&type=script&lang=js"
export * from "./CustomerGenderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports